export default __webpack_public_path__ + "static/media/authImage.52877b48.jpg";